import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import AuthAxios from "../../config/authAxios"
import apiRoutes from "../apiConfigs";

export const quizListApi = createAsyncThunk(
    'auth/quiz',
    async (data, { rejectWithValue }) => {
        try {
            const paramsData = new URLSearchParams(data);
            const response = await AuthAxios.get(apiRoutes.quizList, { params: data })
            return response?.data
        } catch (error) {
            return rejectWithValue(error?.response?.data)
        }
    }
)

const quizSlice = createSlice({
    name: 'quiz',
    initialState: { result: [], loading: false, error: null, message: "", total: 0 },
    extraReducers: (builder) => {
        builder.addCase(quizListApi.pending, (state, action) => {
            state.loading = true
        })
        builder.addCase(quizListApi.fulfilled, (state, action) => {
            state.loading = false
            state.result = action?.payload?.result
            state.message = action?.payload?.message
            state.total = action?.payload?.count
        })
        builder.addCase(quizListApi.rejected, (state, action) => {
            state.loading = false
            state.error = action?.payload?.error
            state.message = action?.payload?.message
        })
    },
})

export const quizListReducer = quizSlice.reducer